var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hero-header",style:(_vm.styleProps)},[_c('h1',{staticClass:"hero-header__title",domProps:{"innerHTML":_vm._s(_vm.title)}}),(_vm.articleAuthor)?_c('AuthorCard',{attrs:{"author":_vm.articleAuthor}}):_vm._e(),_c('div',{staticClass:"hero-header__image-container",style:(_vm.backgroundImageStyle)})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }